import Vue from 'vue'
import moment from 'moment'
import i18n from '@/locales'

// 异步加载项目和角色的组件
const AsyncProjectsRoles = Vue.extend({
  props: {
    projects: {
      type: Array,
      default: () => [],
    },
    roles: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      projectData: [],
      roleData: [],
      loading: true,
    }
  },
  async mounted () {
    if (this.projects.length > 0 && this.roles.length > 0) {
      try {
        const projectManager = new this.$Manager('projects', 'v1')
        const roleManager = new this.$Manager('roles', 'v1')
        const [projectRes, roleRes] = await Promise.all([
          projectManager.batchGet({ id: this.projects }),
          roleManager.batchGet({ id: this.roles }),
        ])
        this.projectData = projectRes.data.data || []
        this.roleData = roleRes.data.data || []
      } catch (error) {
        console.error('Failed to fetch projects and roles:', error)
      } finally {
        this.loading = false
      }
    } else {
      this.loading = false
    }
  },
  render (h) {
    if (this.loading) {
      return h('div', i18n.t('common.loading') + '...')
    }
    const ret = []
    if (this.projectData.length > 0) {
      const projectNames = this.projectData.map(p => p.name || p.id).join(', ')
      ret.push(h('div', `${i18n.t('res.project')}: ${projectNames}`))
    } else if (this.projects.length > 0) {
      ret.push(h('div', `${i18n.t('res.project')}: ${this.projects.join(', ')}`))
    }
    if (this.roleData.length > 0) {
      const roleNames = this.roleData.map(r => r.name || r.id).join(', ')
      ret.push(h('div', `${i18n.t('dictionary.role')}: ${roleNames}`))
    } else if (this.roles.length > 0) {
      ret.push(h('div', `${i18n.t('dictionary.role')}: ${this.roles.join(', ')}`))
    }
    return h('div', ret)
  },
})

export const getExpiredAtColumn = () => {
  return {
    field: 'expired_at',
    title: i18n.t('scope.text_791'),
    sortable: true,
    slots: {
      default: ({ row }, h) => {
        const expiredAt = row.expired_at
        const now = new Date()
        // 未设置
        if (!expiredAt) {
          return [
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center">
                <span class="status-dot" style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#d9d9d9', margin: '0 5px' }}></span>
                <span>{i18n.t('common.not_set')}</span>
              </div>
            </div>,
          ]
        }
        const expiredDate = new Date(expiredAt)
        const isExpired = expiredDate < now
        // 已过期
        if (isExpired) {
          return [
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center">
                <span class="status-dot status-danger" style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#f5222d', margin: '0 5px' }}></span>
                <span>{i18n.t('system.text_558')}</span>
              </div>
            </div>,
          ]
        }
        // 未过期
        return [
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center">
              <span class="status-dot status-success" style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#52c41a', margin: '0 5px' }}></span>
              <span>{i18n.t('common.not_expired')}</span>
            </div>
            <div class="mt-1" style={{ color: '#8c8c8c' }}>
              {moment(expiredAt).format('YYYY-MM-DD HH:mm:ss')}
            </div>
          </div>,
        ]
      },
    },
    formatter: ({ row }) => {
      if (!row.expired_at) return i18n.t('common.not_set')
      const expiredDate = new Date(row.expired_at)
      const now = new Date()
      if (expiredDate < now) {
        return i18n.t('system.text_558')
      }
      return `${i18n.t('common.not_expired')} ${moment(row.expired_at).format('YYYY-MM-DD HH:mm:ss')}`
    },
  }
}

// 通用工单展示配置列
export const getShopCartWorkflowResourceConfigColumn = () => {
  return {
    field: 'config',
    title: i18n.t('common_428'),
    slots: {
      default: ({ row }, h) => {
        const { action, perform_action_name, parameter } = row
        const ret = []
        if (action === 'update') {
          const keys = Object.keys(parameter)
          keys.map(key => {
            if (key === 'displayname') {
              ret.push(<div>{i18n.t('scope.text_245')}: {parameter[key]}</div>)
            } else if (key === 'allow_web_console') {
              ret.push(<div>{i18n.t('system.text_475')}: {parameter[key] ? i18n.t('system.text_134') : i18n.t('system.text_135')}</div>)
            } else if (key === 'enable_mfa') {
              ret.push(<div>MFA: {parameter[key] ? i18n.t('system.text_134') : i18n.t('system.text_135')}</div>)
            } else if (key === 'expired_at') {
              ret.push(<div>{i18n.t('scope.text_791')}: {moment(parameter[key]).format('YYYY-MM-DD HH:mm:ss')}</div>)
            }
          })
        } else if (action === 'perform' && perform_action_name === 'join') {
          const { projects, roles } = parameter
          // 使用 Promise.all 并行获取 projects 和 roles 数据
          if (projects && projects.length > 0 && roles && roles.length > 0) {
            ret.push(h(AsyncProjectsRoles, {
              props: {
                projects,
                roles,
              },
            }))
          } else {
            if (projects && projects.length > 0) {
              ret.push(<div>{i18n.t('res.project')}: {projects.join(', ')}</div>)
            }
            if (roles && roles.length > 0) {
              ret.push(<div>{i18n.t('dictionary.role')}: {roles.join(', ')}</div>)
            }
          }
        }
        return ret.length ? ret : '-'
      },
    },
  }
}
